import SvgIcon from "@mui/material/SvgIcon";

function TikTokIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M19.589 6.686a4.793 4.793 0 0 1-3.77-1.875v8.417a6.5 6.5 0 1 1-5.56-6.436v2.6a3.9 3.9 0 1 0 2.66 3.7V2h2.6a4.8 4.8 0 0 0 4.07 2.286z" />
    </SvgIcon>
  );
}

export default TikTokIcon;
